import {
  FlexBoxImageScaleView,
  FlexBoxView,
  getFlexNode,
} from '@play-co/timestep-core/flexbox';
import uiConfig from 'src/lib/ui/config';
import i18n from 'src/lib/i18n/i18n';
import animate from '@play-co/timestep-core/lib/animate';
import { animDuration, isPlatformGuest } from 'src/lib/utils';
import { ImageView, View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import MenuActionButton, { MenuActionType } from './MenuActionButton';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import sounds from 'src/lib/sounds';
import { openProfile } from '../profile/profile.sequence';
import StateObserver from 'src/StateObserver';
import features from 'src/replicant/ruleset/features';
import platform from '@play-co/gcinstant';

const ui = uiConfig.buruburu.menu;

export default class MainMenu extends FlexBoxImageScaleView {
  constructor() {
    super(ui.menu);

    this.image.onInputStart = () => this.emit('Close');

    const { onSelect } = this;
    const firstRow = this.addSubview(new FlexBoxView(ui.menuRow));
    firstRow.addSubview(
      new MenuActionButton({ type: 'encyclopedia', onSelect }),
    );

    const { user } = StateObserver.getState();

    firstRow.addSubview(
      new MenuActionButton({
        type: 'familyTree',
        onSelect,
        isDisabled: !features(user).familyTree,
      }),
    );
    firstRow.addSubview(
      new MenuActionButton({ type: 'mission', onSelect, isDisabled: true }),
    );

    const secondRow = this.addSubview(new FlexBoxView(ui.menuRow));
    secondRow.addSubview(
      new MenuActionButton({ type: 'decor', onSelect, isDisabled: true }),
    );
    secondRow.addSubview(
      new MenuActionButton({
        type: 'profile',
        onSelect,
        isDisabled: !isPlatformGuest(platform) && !features(user).ingameProfile,
      }),
    );
    secondRow.addSubview(new MenuActionButton({ type: 'settings', onSelect }));

    const closeHint = this.addSubview(new ImageView(ui.closeHintBg));
    closeHint.canHandleEvents(false, true);
    getFlexNode(closeHint).updateStyle({ marginTop: 23 });
    closeHint.addSubview(
      new LangBitmapFontTextView({
        ...ui.closeHintText,
        localeText: () => i18n('footer.tapToClose'),
        width: closeHint.style.width,
        height: closeHint.style.height,
      }),
    );
  }

  fadeIn(superview: View) {
    animate(this)
      .clear()
      .now(() =>
        this.updateOpts({
          superview,
          visible: true,
          opacity: 0,
          offsetY: 100,
        }),
      )
      .then({ opacity: 1, offsetY: 0 }, animDuration, animate.easeOut);
  }

  fadeOut() {
    animate(this)
      .clear()
      .then({ opacity: 0, offsetY: 100 }, animDuration, animate.easeOut)
      .then(() => {
        this.removeFromSuperview();
      });
  }

  private onSelect = async (type: MenuActionType) => {
    sounds.sfx.play('ok');
    switch (type) {
      case 'settings': {
        await openPopupPromise('popupSettings', {});
        return;
      }
      case 'profile': {
        if (isPlatformGuest(platform)) {
          await openPopupPromise('popupNativeLineGuestLogin', {
            origin: 'feature',
          });
          return;
        }

        await openProfile();
        return;
      }
      case 'encyclopedia': {
        await openPopupPromise('popupEncyclopedia', {});
        return;
      }
    }

    this.emit('Close');
  };
}
